<template>
  <div id="app">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
// import { mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    // ...mapActions(["fetchPrivilege"])
  }
};
</script>
<style lang="less">
// .m0 {
//   margin: 0;
// }
// .p16 {
//   padding: 16px;
// }
// .pl16 {
//   padding-left: 16px;
// }
// .pr16 {
//   padding-right: 16px;
// }
// .mt24 {
//   margin-top: 24px;
// }
// .wv100 {
//   width: 100vw;
// }
// .hv100 {
//   height: 100vh;
// }
// .wp100 {
//   width: 100%;
// }
// .hp100 {
//   height: 100%;
// }
</style>
